<template>
  <NuxtImg
    format="webp"
    :src="imageSrc"
    quality="90"
    :height="height"
    :class="props.class"
    :alt="props.alt"
    :load="eager ? 'eager' : 'lazy'"
    :preload="eager"
    @error="onError" />
</template>

<script lang="ts" setup>
const props = defineProps<{
  size: 'sm' | 'md' | 'lg'
  src?: string
  class?: string
  alt: string
  eager?: boolean
}>()
const placeholderImgSrc = '/product-placeholder.png'

const imageSrc = ref(props.src ?? placeholderImgSrc)

watch(
  () => props.src,
  (newSrc) => {
    imageSrc.value = newSrc ?? placeholderImgSrc
  }
)

const height = computed(() => {
  switch (props.size) {
    case 'sm': {
      return '64'
    }

    case 'lg': {
      return '600'
    }

    case 'md':
    default: {
      return '313'
    }
  }
})

const onError = () => {
  imageSrc.value = placeholderImgSrc
}
</script>

<style lang="postcss" scoped></style>
